function extractTransactionNumber(source) {
  const matches = source.toString().match(/\d+/g);

  if (!matches || matches.length === 0) return null;
  return Number(matches[matches.length - 1]);
}

export default extractTransactionNumber;
